import { APIClient } from '../api_helper';
import { api } from '../../config';

const apiClient = new APIClient(api.REACT_APP_SPED_WAREHOUSE_API_URL);

export const createWarehouseGuide = guide => apiClient.post('/guide/', guide);
export const getWarehouseGuides = params =>
	apiClient.get('/guide/', { params });
export const getWarehouseGuide = guideId => apiClient.get(`/guide/${guideId}`);
export const cancelWarehouseGuide = (guideId, data) =>
	apiClient.post(`/guide/${guideId}/cancel`, data);
export const getGuidesStats = params =>
	apiClient.get('/guide/stats/summary', { params });
